import createAxiosInstance from './createAxiosInstance'

const instance = createAxiosInstance(process.env.VUE_APP_CORE_URL)

const addConfig = {
  metadata: {
    customMsg: {
      success: '新增類型成功',
      error: '新增類型失敗'
    }
  }
}

const deleteConfig = {
  metadata: {
    customMsg: {
      success: '刪除類型成功',
      error: '刪除類型失敗'
    }
  }
}

// Swagger: https://local.kingnetsmart.com.tw/core/index.html#/CollectionPayment
export const apiCollectionPayment = {
  GetTypes: () => instance.get('/api/CollectionPayment/Types'), // 取得類型
  PostType: (requestData) => instance.post('/api/CollectionPayment/Type', requestData, addConfig), // 新增類型
  DeleteType: (requestData) => instance.delete('/api/CollectionPayment/Type', Object.assign({}, { data: requestData, ...deleteConfig })) // 刪除類型
}
